import { render, staticRenderFns } from "./UserAvatarOptions.vue?vue&type=template&id=ca2fe294&scoped=true"
import script from "./UserAvatarOptions.vue?vue&type=script&lang=js"
export * from "./UserAvatarOptions.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarOptions.vue?vue&type=style&index=0&id=ca2fe294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2fe294",
  null
  
)

export default component.exports